import { Col, Row } from 'react-bootstrap';
import logo from "../../assets/IESA_Logo_25.png";
import './login.css';
import { Dispatch, useState } from 'react';
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';
import { useForm } from 'react-hook-form';
import CustomButton from '../../components/CustomButton/CustomButton';
import WebService from '../../utility/WebService';
import { toast } from 'react-toastify';
import { USER_LOGIN_SUCCESS } from '../../action/Action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

type FormData = {
    username: string;
    password: string;
}

const Login = () => {
    const { register, handleSubmit, formState: { errors } } = useForm<FormData>();
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const dispatch: Dispatch<any> = useDispatch();
    const navigate = useNavigate();

    const onSubmit = (data: FormData) => {
        setLoading(true);
        WebService.getAccesstoken({
            action: `users/login`,
            body: data,
        })
            .then((res: any) => {
                setLoading(false);
                dispatch({
                    type: USER_LOGIN_SUCCESS,
                    // payload: { access_token: res.data.token },
                });
            })
            .catch((error) => {
                setLoading(false);
                toast.error(error.response?.data?.message);
            });
    }

    return (
        <>
            <div className="login-container">
                <Row className='h-100 ms-0 me-0'>
                    <Col md={12} className='d-flex align-items-center mb-3'>
                        <div className='login-main'>
                            <div className='w-25'>
                                <div className='d-flex justify-content-center'>
                                    <img src={logo} alt="Logo" className='logo' />
                                </div>
                                <div className='sign-in text-center'>Sign in</div>
                                <hr className='line' />
                                <input type="email" placeholder="Email" className='input mt-2' {...register("username", {
                                    required: {
                                        value: true,
                                        message: "Enter Email"
                                    }, pattern: {
                                        value: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
                                        message: "Enter a valid email"
                                    }
                                })} />
                                {errors.username && <div className="error-message">{errors.username.message}</div>}
                                <div className="position-relative mt-3">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        className="input pe-5"
                                        style={{
                                            width: "100%",
                                            height: "40px",                 // ✅ fixed height
                                            padding: "12px 44px 12px 12px", // ✅ space for eye icon
                                            border: "1px solid #ccc",
                                            borderRadius: "10px",
                                            fontSize: "14px",
                                            boxSizing: "border-box",        // 🔥 main fix
                                            outline: "none",
                                            marginBottom: "unset"
                                        }}
                                        {...register("password", { required: "Enter Password" })}
                                    />
                                    <span
                                        // className="password-toggle-icon"
                                        style={{
                                            position: "absolute",
                                            right: "16px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer"
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => setShowPassword(prev => !prev)}
                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                        tabIndex={0}
                                        role="button"
                                    >
                                        {!showPassword ? (
                                            <EyeFill color='#888' />
                                        ) : (
                                            <EyeSlashFill color='#888' />
                                        )}
                                    </span>
                                </div>
                                {errors.password && <div className="error-message">{errors.password.message}</div>}
                                <div className="text-end mt-2">
                                    <span
                                        className="forgot-password"
                                        onClick={() => navigate("/forgot-password")}
                                        style={{
                                            fontSize: "13px",
                                            color: "#0d6efd",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Forgot Password?
                                    </span>
                                </div>
                                <CustomButton isLoading={isLoading} onClick={handleSubmit(onSubmit)} label='Login' className='w-100 mt-4' />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div >
        </>
    )
}

export default Login;